import { MessageSquareText } from 'lucide-react';
import { useAuth } from '../auth/useAuth';
import { useStolStore } from './store';

/**
 * Кнопка Стола в шапке. Видна только владельцу (право stol.access);
 * сам замок — на бэке (403), здесь лишь не рисуем мёртвую дверь.
 * Ставится в каждую шапку (AppShell + Компас) — панель одна на всех.
 */
export function StolHeaderButton({ className }: { className?: string }) {
  const { user } = useAuth();
  const { open, toggle } = useStolStore();
  const canStol = user?.permissions?.includes('stol.access') ?? false;

  if (!canStol) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={open ? 'Закрыть Сессию' : 'Открыть Сессию'}
      title="Сессия — разговор с системой"
      data-testid="stol-toggle"
      className={
        className ??
        'flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-800'
      }
    >
      <MessageSquareText size={18} />
    </button>
  );
}
